import { Container, Graphics } from '@pixi/react'
import { ReactElement, useCallback } from 'react'
import { Draw } from '../type/PixiType'
import { calculateSize } from '../util'

/**
 * @deprecated: Project which using <PixiApp>, do not use this component to avoid unexpected behavior.
 */
export const GrayBackground = (props: { children?: ReactElement, name?: string, isChangePose?: boolean }) => {
  const { scale } = calculateSize()

  const size = Math.max(window.innerWidth, window.innerHeight) / scale * 3
  const draw = useCallback<Draw>(
    (graphics) => {
      graphics.clear()
      graphics.beginFill('black', props.isChangePose ? 1 : 0.8)
      graphics.drawRect(-size / 2, -size / 2, size, size)
      graphics.endFill()
    },
    [props.isChangePose, size],
  )

  return (
    <Container name={props.name ? props.name : 'GrayBackground'} x={0} y={0}>
      <Graphics x={0} y={0} draw={draw} eventMode="static" />
      {props.children}
    </Container>
  )
}
